import { ReactNode } from "react";
import { Breakpoint } from "src/styles/theme";
import { cn } from "src/utils/cn";

const visibleClasses: Record<Breakpoint, string> = {
  sm: "sm:block",
  md: "md:block",
  lg: "lg:block",
  xl: "xl:block",
  "2xl": "2xl:block",
};

const hiddenClasses: Record<Breakpoint, string> = {
  sm: "sm:hidden",
  md: "md:hidden",
  lg: "lg:hidden",
  xl: "xl:hidden",
  "2xl": "2xl:hidden",
};

type VisibleByBreakpointProps = {
  children: ReactNode;
  // including "xs" is just a convenience
  visibleBreakpoints: (Breakpoint | "xs")[];
};

export function VisibleByBreakpoint({
  children,
  visibleBreakpoints,
}: VisibleByBreakpointProps) {
  return (
    <div
      className={cn([
        visibleBreakpoints.includes("xs") ? "block" : "hidden",
        visibleBreakpoints.includes("sm")
          ? visibleClasses.sm
          : hiddenClasses.sm,
        visibleBreakpoints.includes("md")
          ? visibleClasses.md
          : hiddenClasses.md,
        visibleBreakpoints.includes("lg")
          ? visibleClasses.lg
          : hiddenClasses.lg,
        visibleBreakpoints.includes("xl")
          ? visibleClasses.xl
          : hiddenClasses.xl,
        visibleBreakpoints.includes("2xl")
          ? visibleClasses["2xl"]
          : hiddenClasses["2xl"],
      ])}
    >
      {children}
    </div>
  );
}
